import { serviceClient } from '@yola/ws-sdk';

const callSiteBackupMigration = (backupId) => {
  const client = serviceClient.get();
  return client.runSiteBackupMigrations(backupId);
};

export default callSiteBackupMigration;
